
export default {

  rptExcelKunjungan(model) {
      /*if (model) {

      }*/
      let url = 'v2/report/pemeriksaan/tat?';
      if (model.start_date) {
        url += 'start_date=' + model.start_date;
      }

      if (model.end_date) {
        url += '&end_date=' + model.end_date;
      }
      
      return url;
  },
  reportPemeriksaanTatData(model) {
    return window.restApi.get('v2/report/pemeriksaan/tat/data', {params: model});
  },    
}
